var map = {
	"./1AGP.png": 56069,
	"./2AGP.png": 58446,
	"./3AGP.png": 15725,
	"components/Catalog/AGP/img/glass/mt/mtPlusBlack/1AGP.png": 56069,
	"components/Catalog/AGP/img/glass/mt/mtPlusBlack/2AGP.png": 58446,
	"components/Catalog/AGP/img/glass/mt/mtPlusBlack/3AGP.png": 15725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34732;